export const comments_3374306 = {"data":{"data":[],"links":{}}}